<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-card>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>Courses</v-toolbar-title>
        </v-toolbar>
        <v-list 
          two-line 
          subheader>
          <v-list-tile 
            v-for="item in courses" 
            :key="item.code" 
            :to="{path: '/admin/courses/' + item['.key']}"
            avatar 
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="item.code"/>
              <v-list-tile-sub-title v-text="item.name"/>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-card-text>          
          <courseForm 
            :edititem="course" />
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import adminComponents from "@/components/admin";

export default {
  name: "Courses",
  components: {
    ...adminComponents
  },
  data: () => ({
    hidden: false,
    dialog: false,
    valid: true,
    courses: null,
    course: {
      code: null,
      name: null
    }
  }),
  firestore() {
    return {
      courses: this.$store.getters.db.collection("courses").orderBy("code")
    };
  },
  /* watch: {
      'courses': function (val) {
        if (val) {
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    beforeCreate: function () {
      this.$store.dispatch('setLoading', true)
    }, */
  methods: {
    save({ code, name }) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", false);
        let createdAt = new Date();
        this.$store.getters.db
          .collection("courses")
          .doc(code)
          .set({ code, name, createdAt })
          .then(function() {
            console.log("Document successfully written!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Course " + code + " added"
            });
            // self.$store.dispatch('setLoading', false)
            self.$refs.form.reset();
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            // self.$store.dispatch('setLoading', false)
            self.$refs.form.reset();
          });
      }
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
};
</script>
